import { cn } from '@/lib/utils';

const TONE_CLASSES = {
  neutral: 'bg-slate-100 text-slate-700 dark:bg-slate-800 dark:text-slate-300',
  muted: 'bg-slate-100 text-slate-500 dark:bg-slate-800 dark:text-slate-400',
  good: 'bg-emerald-100 text-emerald-800 dark:bg-emerald-900 dark:text-emerald-300',
  bad: 'bg-red-100 text-red-800 dark:bg-red-900 dark:text-red-300',
  info: 'bg-sky-100 text-sky-800 dark:bg-sky-900 dark:text-sky-300'
};

// Короткий счётчик стоит по центру плашки. В широкой значок прижат влево, а цифры вправо: стрелки,
// прочерки и цифры соседних строк образуют ровные столбики.
const WIDTH_CLASSES = {
  sm: 'w-16 justify-center',
  md: 'w-[4.75rem] justify-between'
};

/**
 * Число в колонке таблицы. Плашка одной ширины и у подсвеченного значения, и у обычного (у него
 * она серая): бейдж рядом с голым числом сдвигал строку, и колонка «плыла».
 */
export const TableValue = ({ tone = 'neutral', width = 'sm', icon: Icon, className, children, ...props }) => (
  <span
    data-table-value
    className={cn(
      'inline-flex items-center gap-1 whitespace-nowrap rounded-md px-1.5 py-0.5 font-medium',
      WIDTH_CLASSES[width],
      TONE_CLASSES[tone],
      className
    )}
    {...props}
  >
    {Icon && <Icon aria-hidden="true" className="h-3 w-3 shrink-0" />}
    {children}
  </span>
);
